module.exports = __webpack_public_path__ + "static/media/logo.bcf0214f.svg";